import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../lib/auth';

/** Wraps routes that require a signed-in user. */
export default function ProtectedRoute({ children }) {
  const location = useLocation();
  if (!isAuthenticated()) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return children;
}
